import React from 'react';

const WizardProgressBar = ({ currentStep, steps }) => {
  const total = steps?.length || 1;
  const progress = Math.min(100, Math.round(((currentStep + 1) / total) * 100));

  return (
    <div
      className="h-3 w-full rounded-full bg-muted overflow-hidden"
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`Progression : étape ${currentStep + 1} sur ${total}`}
    >
      <div
        className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default WizardProgressBar;
